import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { colors } from '../../../colors';

export default function ClaimsViewBanner() {

    return (
      <React.Fragment>

        <AppBar position="sticky" sx={{
          backgroundColor: colors.amber,
          }}>
            <Toolbar variant="dense" sx={{
              minHeight: 0,
              justifyContent: 'center'
          }}>
            <Typography variant="caption" color="#000">
              Denne siden viser kun enkelte krav, og ikke en fullstendig oversikt. For å se full oversikt, <a href="/debtorlookup">KLIKK HER</a>
            </Typography>
            </Toolbar>
          </AppBar>
        
      </React.Fragment>
    );
}